module.exports = __webpack_public_path__ + "assets/img/已收货待作业.deb603ae.svg";